var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9341 0.158203H6.22358C3.13561 0.158203 0.63147 2.66235 0.63147 5.75031V12.4608C0.63147 15.5488 3.13561 18.0529 6.22358 18.0529H12.9341C16.0221 18.0529 18.5262 15.5488 18.5262 12.4608V5.75031C18.5262 2.66235 16.0221 0.158203 12.9341 0.158203ZM16.8486 12.4608C16.8486 14.6194 15.0927 16.3753 12.9341 16.3753H6.22358C4.06502 16.3753 2.3091 14.6194 2.3091 12.4608V5.75031C2.3091 3.59176 4.06502 1.83583 6.22358 1.83583H12.9341C15.0927 1.83583 16.8486 3.59176 16.8486 5.75031V12.4608Z",
    fill: "#39373A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57879 4.63184C7.10819 4.63184 5.1051 6.63493 5.1051 9.10552C5.1051 11.5761 7.10819 13.5792 9.57879 13.5792C12.0494 13.5792 14.0525 11.5761 14.0525 9.10552C14.0525 6.63493 12.0494 4.63184 9.57879 4.63184ZM9.57879 11.9016C8.0376 11.9016 6.78273 10.6467 6.78273 9.10552C6.78273 7.56322 8.0376 6.30947 9.57879 6.30947C11.12 6.30947 12.3748 7.56322 12.3748 9.10552C12.3748 10.6467 11.12 11.9016 9.57879 11.9016Z",
    fill: "#39373A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3881 4.89243C14.7173 4.89243 14.9842 4.62554 14.9842 4.29631C14.9842 3.96709 14.7173 3.7002 14.3881 3.7002C14.0589 3.7002 13.792 3.96709 13.792 4.29631C13.792 4.62554 14.0589 4.89243 14.3881 4.89243Z",
    fill: "#39373A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8947,
    height: 17.8947,
    fill: "white",
    transform: "translate(0.63147 0.158203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.fd5463b7d5c135297c09ce1f10ea3206.svg";
export { ForwardRef as ReactComponent };